module.exports = __webpack_public_path__ + "img/ic-payment-failure.57dc0e89.svg";